<!--
	@name app-common-api-health-item
	@description Load products via API
	@date 2020/07/06
	@license no license
	@copywrite Answers In Retirement Limited
-->

<template>
	<div>
		<v-list-item :component="$options.name" :class="[{ 'my-1': !standardLayout }, standardLayout ? 'white' : apiHealthColor]" :dense="standardLayout">
			<v-list-item-avatar v-if="standardLayout" size="28" class="ma-0">
				<v-icon :color="apiHealthColor" size="27">
					mdi-circle-slice-8
				</v-icon>
			</v-list-item-avatar>
			<v-list-item-content class="pl-3">
				<v-list-item-title :class="[standardLayout ? 'text-body-1' : 'text-h5', { 'white--text': !standardLayout && apiHealthColor === 'success' }]">
					{{ provider.name }}
				</v-list-item-title>
			</v-list-item-content>
			<v-list-item-action v-if="standardLayout">
				<v-list-item-action-text v-if="apiHealthActive">
					<v-btn text small @click="openDialog">
						View Details
					</v-btn>
				</v-list-item-action-text>
			</v-list-item-action>
		</v-list-item>

		<common-dialog ref="dialog" :max-width="600" :color="apiHealthColor">
			<template #header>
				{{ provider.name }}
			</template>
			<template #body>
				<p class="text-body-1 mb-0">
					{{ apiHealthMessage }}
				</p>
			</template>
		</common-dialog>
	</div>
</template>

<script>
	import CommonDialog from '@/component/common/dialog';
	import ApiHealth from '@/mixins/api-health';

	export default {
		name: 'app-common-api-health-item',

		components: { CommonDialog },

		mixins: [ApiHealth],

		props: {
			provider: { type: Object, required: true },
			layout: { type: String, default: 'default' }
		},

		data() {
			return {};
		},

		computed: {
			standardLayout() {
				return this.layout === 'default';
			}
		},

		methods: {
			/**
			 * @name openDialog
			 * @description open error details dialog
			 */
			openDialog() {
				this.$refs.dialog.open();
			},

			/**
			 * @name closeDialog
			 * @description close error details dialog
			 */
			closeDialog() {
				this.$refs.dialog.close();
			}
		}
	};
</script>
